import { action } from 'easy-peasy';
import { IActionSetUserAssociatedPrograms } from '../types';

const setUsersAssociatedPrograms: IActionSetUserAssociatedPrograms = action((state, payload) => {
  state.userAssociatedPrograms = payload;
});

export default setUsersAssociatedPrograms;
